import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgSignaturePadOptions, SignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
    selector: 'de-signature-dialog',
    templateUrl: './signature-dialog.component.html',
    styleUrls: ['./signature-dialog.component.scss'],
    standalone: false
})
export class SignatureDialogComponent {

  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;

  public signaturePadOptions = { // passed through to szimek/signature_pad constructor
    minWidth: 5,
  };

  @Output() isClosed = new EventEmitter<boolean>(false);
  @Output() isSaved = new EventEmitter<string>();


  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }

 
  save() {
    this.isSaved.emit(this.signaturePad.toDataURL());
  }

  cancel() {
    this.isClosed.emit(true);
  }
}
